import { isValidPrice } from '@domain-group/javascript-utils'

export type PublicationProductModel = {
  bleed: number,
  cache_key: number,
  columns: number,
  height: number,
  id: number,
  product_code?: string,
  publication_id: number,
  rows: number,
  title: string,
  width: number,
}

export type PublicationProductRequestOptions = {}

const state = {
  bleed: '',
  columns: '',
  height: '',
  id: null,
  product_code: '',
  publication_id: undefined,
  rows: '',
  title: '',
  width: '',
}

export const requiredFields = [
  {
    key: 'bleed',
    validation: isValidPrice,
    invalidMessage: 'Cannot be negative',
  },
  {
    key: 'columns',
    validation: isValidPrice,
  },
  {
    key: 'height',
    validation: isValidPrice,
    invalidMessage: 'Cannot be negative',
  },
  { key: 'publication_id' },
  {
    key: 'rows',
    validation: isValidPrice,
  },
  { key: 'title' },
  {
    key: 'width',
    validation: isValidPrice,
    invalidMessage: 'Cannot be negative',
  },
]

export default state
